module.exports = __webpack_public_path__ + "static/media/B.409e0b57.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/B.svg
// module id = 291
// module chunks = 0